import { render } from "./LegnaInSacchiView.vue?vue&type=template&id=b0bab686"
const script = {}

import "./LegnaInSacchiView.vue?vue&type=style&index=0&id=b0bab686&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__